// Saved as an answer when a quiz shows its last page, under this key.
export const QUIZ_CONCLUSION_ANSWER = "Conclusion";

// Where a line of the text ends and starts: both sides of each of these, and every line break.
const BLOCK_ELEMENTS = "p, div, h1, h2, h3, h4, h5, h6, ul, ol, li, blockquote, section, article, header, footer, table, tr, hr";

// The text of a last page's html, one line for each block, without styles. The markup is parsed in a document
// of its own, so its images don't load and its handlers don't run.
export const getQuizConclusion = (html: string) => {
    const { body } = new DOMParser().parseFromString(html, "text/html");
    body.querySelectorAll("style, script").forEach((node) => node.remove());

    // Line breaks in the markup are only whitespace; the lines of the text are the blocks and <br>s.
    const walker = body.ownerDocument.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) node.textContent = (node.textContent ?? "").replace(/\s+/g, " ");

    body.querySelectorAll("br").forEach((lineBreak) => lineBreak.replaceWith("\n"));
    body.querySelectorAll(BLOCK_ELEMENTS).forEach((block) => {
        block.prepend("\n");
        block.append("\n");
    });

    return (body.textContent ?? "")
        .split("\n")
        .map((line) => line.replace(/\s+/g, " ").trim())
        .filter(Boolean)
        .join("\n");
};
